import { Spinner } from '@chakra-ui/react';
import React, { useMemo } from 'react';

import {
  useGetResolvedLoanByFundingRequestAndCommitmentKeyQuery,
  ShareFundingComponentFragmentGQLType,
} from 'packages/loans/requests/loans.gql.generated';
import { DownloadLiveFundingNoticeButton } from 'packages/loans/ui/DownloadLiveFundingNoticeButton';

type DownloadFundingNoticeButtonProps = {
  fundingRequestId: string;
  commitmentKey: string;
  capitalProviderOrganizationId: string;
};

export const DownloadLiveFundingNoticeFromFundingRequestButton = ({
  fundingRequestId,
  commitmentKey,
  capitalProviderOrganizationId,
}: DownloadFundingNoticeButtonProps) => {
  const {
    data: loansData,
    loading: isLoansDataLoading,
  } = useGetResolvedLoanByFundingRequestAndCommitmentKeyQuery({
    fetchPolicy: 'network-only',
    variables: { fundingRequestId, commitmentKey },
  });

  const fundingComponent = useMemo<ShareFundingComponentFragmentGQLType | null>(() => {
    if (!loansData?.loan) return null;

    const request = loansData.loan.funding.requests.find(
      (r) => r.fundingRequestId === fundingRequestId,
    );
    if (!request) return null;

    const fc = request.fundingComponents.find(
      (f) => f.lenderOrganizationId === capitalProviderOrganizationId,
    );

    return fc ?? null;
  }, [loansData, fundingRequestId, capitalProviderOrganizationId]);

  if (isLoansDataLoading) {
    return <Spinner />;
  }

  if (!fundingComponent) {
    return null;
  }

  return (
    <DownloadLiveFundingNoticeButton
      lenderShareId={fundingComponent.lenderShareId}
      fundingRequestComponentId={fundingComponent.fundingRequestComponentId}
    />
  );
};
